import type { Batteries } from '~/types/equipment';

import installationRiskHttp from '~/services/installation-risk-api/installation-risk-api.http';

class BatteriesService {
  private readonly endpoint = '/v1/batteries';

  private static buildQueryString(params: any): string {
    const searchParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, value.toString());
      }
    });

    return searchParams.toString();
  }

  async create(data: Batteries.CreateBatteryRequest): Promise<Batteries.Battery> {
    const response = await installationRiskHttp.post(this.endpoint, data);
    return response.data;
  }

  async getById(id: number): Promise<Batteries.Battery> {
    const response = await installationRiskHttp.get(`${this.endpoint}/${id}`);
    return response.data;
  }

  async list(params: Batteries.GetBatteriesRequest): Promise<any> {
    const queryString = BatteriesService.buildQueryString(params);
    const url = queryString ? `${this.endpoint}?${queryString}` : this.endpoint;
    const response = await installationRiskHttp.get(url);
    return response.data;
  }

  async update(id: number, data: Batteries.UpdateBatteryRequest): Promise<Batteries.Battery> {
    const response = await installationRiskHttp.put(`${this.endpoint}/${id}`, data);
    return response.data;
  }
}

const batteriesService = new BatteriesService();

export default batteriesService;
